import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { DatePicker } from "rsuite";
import { Modal, Spinner } from "reactstrap";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import UploadPlusIcon from "../../../components/Icons/UploadPlusIcon";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import ErrorMessage from "../../../components/comman/ErrorMessage";
import { formatAmount } from "../../../utility/CommonFunctions";
import moment from "moment";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";

export default function CreateVoucherModal({
  isOpen,
  toggle,
  paymentTicketDetails,
  GetPaymentTicketDetail,
  GetVoucherList,
  from = "",
}) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    watch,
    reset,
    setValue,
    setError,
    control,
  } = useForm({ mode: "onBlur" });
  const [isLoading, setIsLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState();
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };

  // console.log("paymentTicketDetail===>", paymentTicketDetails);

  const methodType = watch("paymentMethod");

  useEffect(() => {
    setValue(
      "bankName",
      paymentTicketDetails?.purchase?.vendor?.bankName ||
      paymentTicketDetails?.vendor?.bankName ||
      paymentTicketDetails?.receipientUser?.userdetail?.bankName ||
      "--",
    );
    setValue(
      "accountNumber",
      paymentTicketDetails?.purchase?.vendor?.accountNumber ||
      paymentTicketDetails?.vendor?.accountNumber ||
      paymentTicketDetails?.receipientUser?.userdetail?.accountNumber ||
      "--",
    );
    setValue(
      "accountHolderName",
      paymentTicketDetails?.purchase?.vendor?.accountHolderName ||
      paymentTicketDetails?.vendor?.accountHolderName ||
      paymentTicketDetails?.receipientUser?.userdetail?.accountHolderName ||
      "--",
    );
    setValue(
      "ifscCode",
      paymentTicketDetails?.purchase?.vendor?.ifscCode ||
      paymentTicketDetails?.vendor?.ifscCode ||
      paymentTicketDetails?.receipientUser?.userdetail?.ifscCode ||
      "--",
    );
    setValue(
      "branchName",
      paymentTicketDetails?.purchase?.vendor?.branchName ||
      paymentTicketDetails?.vendor?.branchName ||
      paymentTicketDetails?.receipientUser?.userdetail?.branchAddress ||
      "--",
    );
  }, [paymentTicketDetails, methodType]);

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (selectedFile.size > 6 * 1024 * 1024) {
        toast.error("File size must be less than 6MB");
        event.target.value = "";
        return;
      }
      setFiles((prevFiles) => [
        ...prevFiles,
        { key: selectedFile.name, file: selectedFile }, // Use file name as key
      ]);
    }
    event.target.value = ""; // Allow reselecting the same file
  };

  const removeFile = (fileName) => {
    setFiles((prevFiles) =>
      prevFiles.filter((fileObj) => fileObj.key !== fileName),
    );
  };

  const closeHandler = () => {
    toggle();
    reset();
  };

  const onSubmit = (data) => {
    const isBankTransfer = ["IMPS", "RTGS", "NEFT"].includes(methodType);
    const submitData = {
      vendorId: paymentTicketDetails?.purchase?.vendorId,
      ...(from === "salaryTicket"
        ? { salaryTicketId: paymentTicketDetails?.id }
        : { paymentTicketId: paymentTicketDetails?.id }),
      companyId: paymentTicketDetails?.site?.companyId,
      siteId: paymentTicketDetails?.siteId,
      accountHolderName: isBankTransfer ? data?.accountHolderName || "" : "",
      accountNumber: isBankTransfer ? data?.accountNumber || "" : "",
      bankName: isBankTransfer ? data?.bankName || "" : "",
      ifscCode: isBankTransfer ? data?.ifcsCode || "" : "",
      branchName: isBankTransfer ? data?.branchName || "" : "",
      paymentMethod: data?.paymentMethod,
      referenceName: data?.referenceName,
      remark: data?.remark,
      transactionAmount: data?.transactionAmount,
      transactionDate: data?.transactionDate,
      utrNumber: data?.utrNumber,
      financialYear: paymentTicketDetails?.financialYear,
    };
    // console.log("SubmitData=====:>", submitData);

    const formData = new FormData();
    Object.keys(submitData).forEach((key) => {
      const value = submitData[key];
      if (value) {
        formData.append(key, value);
      }
    });
    if (files?.length > 0) {
      files.forEach((fileObj) => {
        // formData.append("document", fileObj.file);
        formData.append(fileObj?.file?.name, fileObj.file);
      });
    }
    const option = {
      method: "POST",
      form_data: formData,
    };

    const endPoint = apiUrl.create_voucher;
    setIsLoading(true);
    callApi(endPoint, option).then((res) => {
      setIsLoading(false);
      if (res?.status === true) {
        toast.success("Payment Advisory Created");
        GetPaymentTicketDetail();
        GetVoucherList();
        closeHandler();
      } else {
        toast.error(res?.message);
      }
    });
  };
  return (
    <Modal
      className="modal-dialog modal-dialog-scrollable modal-xl modal-dialog-centered payment-advisory-modal"
      id="leaveModal"
      isOpen={isOpen}
      toggle={() => closeHandler()}
    >
      <div className="modal-content">
        <div className="modal-header p-4 border-0">
          <h1
            className="modal-title fs-3 rajdhani-semibold"
            id="attendanceModalLabel"
          >
            Create Payment Advisory
          </h1>
          <button
            type="button"
            className="btn-close"
            onClick={() => closeHandler()}
          />
        </div>
        <div className="modal-body p-4">
          <form id="leaveRequestForm" onSubmit={handleSubmit(onSubmit)}>
            <div className="row py-3 mb-4 border-bottom border-top bg-light rounded shadow-sm">
              <div className="col-md-6 mb-2 mb-md-0 d-flex flex-column align-items-center">
                <span className="text-muted fw-semibold">Total Amount</span>
                <span className="fs-4 text-success fw-bold">
                  {formatAmount(paymentTicketDetails?.totalAmount) || "--"}
                </span>
              </div>
              <div className="col-md-6 d-flex flex-column align-items-center">
                <span className="text-muted fw-semibold">Remaining Amount</span>
                <span className="fs-4 text-danger fw-bold">
                  {(paymentTicketDetails?.remainingAmount &&
                    formatAmount(paymentTicketDetails?.remainingAmount)) ||
                    formatAmount(paymentTicketDetails?.totalAmount)}
                </span>
              </div>
            </div>

            <div className="row">
              <div className="col-6">
                <div className="form-group mb-3">
                  <label htmlFor="date" className="form-label">
                    Transaction Date <span className="text-danger">*</span>
                  </label>
                  <div className="input-group mb-3 DatePicker">
                    <Controller
                      name="transactionDate"
                      control={control}
                      rules={{
                        required: "Transaction Date is required",
                        validate: (value) => {
                          const ticketDate = paymentTicketDetails?.date ? moment(paymentTicketDetails?.date).startOf('day') : null;
                          const today = moment().startOf('day');
                          const checkDate = moment(value).startOf('day');
                          if (ticketDate && checkDate.isBefore(ticketDate)) {
                            return `Date cannot be before ticket date (${ticketDate.format("DD/MM/YYYY")})`;
                          }
                          if (checkDate.isAfter(today)) {
                            return "Future dates are not allowed";
                          }
                          return true;
                        }
                      }}
                      defaultValue={moment().format("YYYY-MM-DD")}
                      render={({ field }) => (
                        <DatePicker size="sm"
                          {...field}
                          format="dd/MM/yyyy"
                          oneTap
                          placeholder="dd/mm/yyyy"
                          style={{ width: "100%" }}
                          value={field.value ? new Date(field.value) : null}
                          onChange={(date) => {
                            field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                          }}
                          shouldDisableDate={(date) => {
                            const ticketDate = paymentTicketDetails?.date ? moment(paymentTicketDetails?.date).startOf('day') : null;
                            const today = moment().startOf('day');
                            const checkDate = moment(date).startOf('day');
                            return (ticketDate && checkDate.isBefore(ticketDate)) || checkDate.isAfter(today);
                          }}
                          container={() => document.querySelector('.payment-advisory-modal .modal-content') || document.body}
                          cleanable={false}
                        />
                      )}
                    />
                  </div>
                  <ErrorMessage message={errors?.transactionDate?.message} />
                </div>
              </div>
              <div className="col-6">
                <label className="form-label">
                  Payment Method <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select"
                  {...register("paymentMethod", {
                    required: "Payment Method is required",
                    onChange: (e) => {
                      const value = e.target.value;

                      // clear dependent fields
                      setValue("bankName", "");
                      setValue("accountHolderName", "");
                      setValue("accountNumber", "");
                      setValue("ifscCode", "");
                      setValue("branchName", "");
                      setValue("utrNumber", "");
                      setValue("referenceName", "");

                      // If you need to preserve the selected value, update it too
                      setValue("paymentMethod", value);
                    },
                  })}
                >
                  <option value="">Select Payment Method</option>
                  <option value="Credit / Debit Card">
                    Credit / Debit Card
                  </option>
                  <option value="UPI">UPI</option>
                  <option value="NEFT">NEFT</option>
                  <option value="RTGS">RTGS</option>
                  <option value="IMPS">IMPS</option>
                  <option value="Cash">Cash</option>
                </select>
                <ErrorMessage message={errors?.paymentMethod?.message} />
              </div>

              {methodType !== "Cash" && (
                <div className="col-6">
                  <div className="form-group mb-3">
                    <label htmlFor="transactionAmount" className="form-label">
                      UTR Number <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="holderName"
                      placeholder="UTR Number"
                      {...register("utrNumber", {
                        required: "UTR Number is required",
                      })}
                    />
                    <ErrorMessage message={errors?.utrNumber?.message} />
                  </div>
                </div>
              )}
              {(methodType === "NEFT" ||
                methodType === "RTGS" ||
                methodType === "IMPS") && (
                  <>
                    <div className="col-6">
                      <div className="form-group mb-3">
                        <label htmlFor="bankName" className="form-label">
                          Bank Name <span className="text-danger">*</span>
                        </label>
                        <div className="input-group mb-3 DatePicker">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Bank Name"
                            disabled={paymentTicketDetails?.type !== "General"}
                            {...register("bankName", {
                              required: "Bank Name is required",
                            })}
                          />
                        </div>
                        <ErrorMessage message={errors?.bankName?.message} />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group mb-3">
                        <label htmlFor="accountHolderName" className="form-label">
                          Account Holder Name{" "}
                          <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="holderName"
                          placeholder="Account Holder Name"
                          disabled={paymentTicketDetails?.type !== "General"}
                          {...register("accountHolderName", {
                            required: "Account holder name is required",
                          })}
                        />
                        <ErrorMessage
                          message={errors?.accountHolderName?.message}
                        />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group mb-3">
                        <label htmlFor="accountNumber" className="form-label">
                          Account Number <span className="text-danger">*</span>
                        </label>
                        <input
                          type="number"
                          onWheel={(e) => e.target.blur()}
                          className="form-control"
                          id="accountNumber"
                          placeholder="Account Number"
                          disabled={paymentTicketDetails?.type !== "General"}
                          {...register("accountNumber", {
                            required: "Account Number is required",
                          })}
                        />
                        <ErrorMessage message={errors?.accountNumber?.message} />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group mb-3">
                        <label htmlFor="ifscCode" className="form-label">
                          IFSC Code <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="ifscCode"
                          placeholder=" IFSC Code"
                          disabled={paymentTicketDetails?.type !== "General"}
                          {...register("ifscCode", {
                            required: "ifsc code is required",
                          })}
                        />
                        <ErrorMessage message={errors?.ifscCode?.message} />
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="form-group mb-3">
                        <label htmlFor="branchName" className="form-label">
                          Branch Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="branchName"
                          placeholder="Branch Name"
                          disabled={paymentTicketDetails?.type !== "General"}
                          {...register("branchName", {
                            required: "Branch Name is required",
                          })}
                        />
                        <ErrorMessage message={errors?.branchName?.message} />
                      </div>
                    </div>
                  </>
                )}

              {methodType === "Cash" && (
                <div className="col-6">
                  <div className="form-group mb-3">
                    <label htmlFor="transactionAmount" className="form-label">
                      Reference Name <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="holderName"
                      placeholder="Reference Name"
                      {...register("referenceName", {
                        required: "Reference Name is required",
                      })}
                    />
                    <ErrorMessage message={errors?.referenceName?.message} />
                  </div>
                </div>
              )}

              {/* Transaction Amount */}
              <div className="col-6">
                <div className="form-group mb-3">
                  <label htmlFor="transactionAmount" className="form-label">
                    Transaction Amount <span className="text-danger">*</span>
                  </label>

                  <input
                    type="number"
                    step="0.01"
                    className="form-control"
                    id="transactionAmount"
                    placeholder="Transaction amount"
                    {...register("transactionAmount", {
                      required: "Transaction Amount is required",
                      valueAsNumber: true,
                      validate: (value) => {
                        const maxAmount = Number(
                          paymentTicketDetails?.remainingAmount ??
                          paymentTicketDetails?.totalAmount ??
                          0
                        )

                        return (
                          Number(value) <= maxAmount ||
                          `Amount must not exceed Remaining Amount ${formatAmount(maxAmount)}`
                        )
                      },
                    })}
                    onWheel={(e) => e.target.blur()}
                  />

                  <ErrorMessage message={errors?.transactionAmount?.message} />
                </div>
              </div>

              <div className="row">
                <div className="col-12 " />
                <div className="col-12 col-md-6 col-lg-5">
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="ref">
                      Payment References
                    </label>
                    <input
                      type="file"
                      className="form-control d-none"
                      id="documentUpload"
                      accept="image/*,application/pdf"
                      onChange={handleFileChange}
                    />
                    <label
                      htmlFor="documentUpload"
                      className="form-label rounded-4 cursor-pointer d-flex align-items-center justify-content-center"
                      style={{
                        display: "inline-block",
                        cursor: "pointer",
                        padding: 5,
                        backgroundColor: "rgb(245, 245, 245)",
                        borderRadius: 8,
                        minWidth: 150,
                      }}
                    >
                      <div className="d-flex flex-column">
                        <span className="placeholder-img">
                          <UploadPlusIcon />
                        </span>
                        <span className="text-muted">Choose Files </span>
                      </div>
                    </label>
                    <div className="preview-section p-1 mt-3" />
                  </div>
                </div>
              </div>
              {/* File Preview Section */}
              <div className="preview-section p-1 mt-3 col-lg-5">
                {files?.length > 0 &&
                  files.map((fileObj) => (
                    <div
                      key={fileObj.key} // Using file name as key
                      className="d-flex align-items-center justify-content-between p-1 border rounded mb-2"
                      style={{ backgroundColor: "#f8f9fa", cursor: "pointer" }}
                    >
                      <div
                        className="w-100"
                        onClick={() => {
                          setSelectedDocument(fileObj?.file);
                          toggleModal();
                        }}
                      >
                        <span className="fs-5">{fileObj?.file?.name}</span>
                      </div>
                      <button
                        className="text-danger mx-2 bg-light"
                        onClick={() => removeFile(fileObj.key)} // Remove using file name
                      >
                        <DeleteIcon />
                      </button>
                    </div>
                  ))}
              </div>
            </div>

            <div className="col-6">
              <div className="form-group mb-3">
                <label htmlFor="desc" className="form-label">
                  Remark
                </label>
                <textarea
                  className="form-control "
                  id="desc"
                  rows={3}
                  name="remark"
                  {...register("remark", {
                    // required: "This field is Required",
                  })}
                />
                <ErrorMessage message={errors?.remark?.message} />
              </div>
            </div>
            <div className="d-flex gap-2 justify-content-end">
              <button
                className="btn btn-secondary"
                type="button"
                onClick={() => closeHandler()}
              >
                Cancel
              </button>
              <button className="btn btn-primary" type="submit">
                {isLoading ? <Spinner /> : "Create"}
              </button>
            </div>
          </form>
        </div>
      </div>
      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
    </Modal>
  );
}
